export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7385.212103f4.jpg";